const data=[
    {id:1,Link:'#',title:'Home'},
    {id:2,Link:'#about',title:'About'},
    {id:3,Link:'#experience',title:'Experience'},
    {id:4,Link:'#portfolio',title:'Projects'},
    {id:5,Link:'#certifications',title:'Certifications'},
    {id:6,Link:'#contact',title:'Contact'},
    
]

export default data;